<template>
  <el-dialog title="导出设置" :visible.sync="exportDialogShow" width="520px" :close-on-click-modal="false" id='printDialog_ss'>
    <div class='print_container'>

       <div>
        <span class='printTitle'>导出类型：</span>
        <div style='margin-top: 20px;margin-left: 10px;'>
             <el-radio v-model="printFormData.exportScope" label="1">当前勾选</el-radio>
             <el-radio v-model="printFormData.exportScope" label="2">当前期间全部</el-radio>
        </div>

      </div>
      <div style='margin-top: 20px;'>
        <span class='printTitle'>导出范围：</span>
        <div style='margin-top: 20px;margin-left: 10px;'>
             <el-radio v-model="printFormData.exportType" label="1">导出Excel</el-radio>
             <el-radio v-model="printFormData.exportType" label="2">导出单据PDF</el-radio>
        </div>

      </div>
      <div style='margin-top: 20px;'>
        <span class='printTitle'>导出内容：</span>
        <div style='margin-top: 20px;margin-left: 10px;'>
            <el-checkbox-group v-model="printFormData.checkList" >
              <el-checkbox v-for='item in PDFcustomList' :label="item.id" :disabled='item.type' :key='item.id'>{{item.name}}</el-checkbox>
            </el-checkbox-group>
        </div>
      </div>
      <div style='margin-top: 20px;text-align: right;'>
        <el-button size="small" class='minButton' @click='handleExport'>导出</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    data() {
      return {
        exportDialogShow:false,
        PDFcustomList:[],
        printFormData:{
          exportType:"1",
          exportScope:"2",
          checkList:[],
        }
      }
    },
    methods:{
      handleExport() {
        this.$emit("export",this.printFormData)
      },
    }
  }
</script>

<style lang="less">
  #printDialog_ss {
       .el-dialog__header {
         border-bottom: 1px solid #eee;
       }
       .printTitle {
         font-weight: bold;
         color: #666;
       }
       .el-checkbox {
         margin-bottom: 10px;
       }

     }
</style>



// WEBPACK FOOTER //
// src/pages/cashier/components/c-query-table/c-export.vue